import React, { useState } from "react";
import CommonLayout from "../CommonLayout";

import Delete_Account_Header from "../../../Assets/delete_account_header.png";
import "./index.css";
import { Button, notification, PageHeader, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { UserRespose } from "../../../redux/Reducer/userReducer";
import OTPInputComponent from "../../Common/Components/OTPModal";
import {
  deleteUser,
  deleteUserInitiate,
} from "../../../Services/AuthenticationServices/AuthenticationServices";
import {
  setAccessToken,
  setPhoneNumber,
  setVuaId,
} from "../../../Services/LocalStorageServices";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../Utils/Constants/routes";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { translation } from "../../../i18n/translationConstant";

const DeleteAccount: React.FC<{ user: UserRespose }> = ({ user }) => {
  const { t } = useTranslation();
  const [isOTPModalVisible, setIsOTPModalVisible] = useState(false);
  const [OTPId, setOTPId] = useState("");
  const history = useHistory();

  const closeModal = () => {
    setIsOTPModalVisible(false);
  };

  const handleDeleteAccount = () => {
    deleteUserInitiate()
      .then((res) => res.data)
      .then((res) => {
        setOTPId(res);
        setIsOTPModalVisible(true);
      });
  };
  const { replace } = useHistory();
  const verifyDeleteAccount = (otp: string) => {
    deleteUser({
      otpUniqueID: OTPId,
      code: otp,
    }).then(() => {
      setAccessToken("");
      setPhoneNumber("");
      setVuaId("");
      notification.success({
        message: t("Account Deleted"),
      });
      replace(Routes.login);
    });
  };

  const goBack = () => {
    history.goBack();
  };

  return (
    <CommonLayout>
      <PageHeader
        className="linkAccountTitle"
        backIcon={<ArrowLeftOutlined className="backIcon" onPointerOverCapture={undefined} onPointerMoveCapture={undefined}/>}
        onBack={goBack}
        title={t(translation.lblDeleteAccount)}
        style={{paddingLeft:'50px', paddingTop:'30px'}}
      />
      <OTPInputComponent
        onCancel={closeModal}
        isOpen={isOTPModalVisible}
        onOtpSubmit={verifyDeleteAccount}
        okText={t("lblConfirm")}
        title={t("DeleteAccount")}
        // tslint:disable-next-line: jsx-no-lambda
        onResend={handleDeleteAccount}
      />

      <div className="row alignCenter justifyCenter">
        <img
          src={Delete_Account_Header}
          alt="My Profile"
          className="deleteAccountImage marginTop30"
        />
      </div>

      <Typography.Text className="font24 fontWeight700 marginTop10">
        {t("lblHi") + " " + user.firstName}
      </Typography.Text>
      <Typography.Text className="deleteAccountText marginTop10">
        {t("lblDeleteAccountText")}
      </Typography.Text>

      <Typography.Text className="deleteAccountConfirmation marginTop10">
        {t("lblSureToDeleteAccount").toUpperCase()}
      </Typography.Text>

      <div className="row justifyCenter marginTop30 width100  ">
        <Button onClick={handleDeleteAccount} className="accountDeleteButton">
          {t("lblDeleteAccount")}
        </Button>
      </div>
    </CommonLayout>
  );
};

const mapStateToProps = (state: any) => ({
  user: state.user.user,
});

export default connect(mapStateToProps)(DeleteAccount);
